/* theme.js — SKINS. Reveals, galerie, quantité, menu mobile, cart drawer AJAX. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FREE_SHIP = (window.SKINS && window.SKINS.freeShip) || 4900; // cents
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };

  /* ---------- Reveals ---------- */
  function initReveals() {
    var hero = document.querySelector('.hero');
    if (hero) hero.classList.add('is-in');
    var targets = document.querySelectorAll('.reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Galerie produit (swap sans requête réseau) ---------- */
  function initGallery() {
    var main = document.getElementById('galMain');
    if (!main) return;
    var thumbs = document.querySelectorAll('.thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.querySelector('img');
        if (main.src === img.src) return;
        main.src = img.src; main.alt = img.alt;
        main.style.animation = 'none'; void main.offsetWidth; main.style.animation = '';
        thumbs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- Sélecteur de quantité ---------- */
  function initQty() {
    document.querySelectorAll('.qty').forEach(function (q) {
      var n = 1, out = q.querySelector('span'), bs = q.querySelectorAll('button');
      bs[0].addEventListener('click', function () { if (n > 1) { n--; out.textContent = n; } });
      bs[1].addEventListener('click', function () { if (n < 12) { n++; out.textContent = n; } });
    });
  }

  /* ---------- Menu mobile ---------- */
  function initMobileMenu() {
    var burger = document.querySelector('.burger');
    var mnav = document.querySelector('.mnav');
    if (!burger || !mnav) return;
    var close = mnav.querySelector('.mnav-close');
    burger.addEventListener('click', function () {
      mnav.classList.add('open'); mnav.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden';
    });
    function hide() {
      mnav.classList.remove('open'); mnav.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = '';
    }
    if (close) close.addEventListener('click', hide);
    mnav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', hide); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer, overlay;
  function openCart() { if (drawer) { drawer.classList.add('open'); overlay.classList.add('open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); overlay.classList.remove('open'); } }

  function renderCart(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('.cart-body');
    var count = cart.item_count;
    document.querySelectorAll('.nav-cta .cart-count').forEach(function (el) { el.textContent = count; });
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-empty">Votre panier est vide.</p>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '">' : '<span></span>';
        return '<div class="cart-item">' + img +
          '<div><p class="ci-t">' + esc(it.product_title) + '</p><p class="ci-m">Qté ' + esc(it.quantity) + '</p></div>' +
          '<p class="ci-p">' + money(it.final_line_price) + '</p></div>';
      }).join('');
    }
    var sub = drawer.querySelector('.cart-sub .v');
    if (sub) sub.textContent = money(cart.total_price);
    var ship = drawer.querySelector('.cart-ship');
    if (ship) {
      if (cart.total_price >= FREE_SHIP) ship.textContent = 'Livraison offerte débloquée.';
      else ship.textContent = 'Plus que ' + money(FREE_SHIP - cart.total_price) + ' pour la livraison offerte.';
    }
  }

  function refreshCart(open) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); });
  }

  function initCart() {
    drawer = document.querySelector('.cart-drawer');
    overlay = document.querySelector('.cart-overlay');
    if (!drawer) return;
    var close = drawer.querySelector('.cart-close');
    if (close) close.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
    document.querySelectorAll('.nav-cta, .js-cart-open').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
    });
    // Add to cart
    document.querySelectorAll('.add[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qtyEl = btn.closest('.qty-row') && btn.closest('.qty-row').querySelector('.qty span');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        btn.disabled = true; var label = btn.textContent; btn.textContent = 'Ajout…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: btn.getAttribute('data-variant-id'), quantity: qty })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Ajout impossible'); });
          return r.json();
        }).then(function () { refreshCart(true); })
          .catch(function (err) { btn.textContent = err.message || 'Indisponible'; setTimeout(function () { btn.textContent = label; }, 2000); })
          .finally(function () { btn.disabled = false; if (btn.textContent === 'Ajout…') btn.textContent = label; });
      });
    });
    refreshCart(false);
  }

  function init() {
    initReveals(); initGallery(); initQty(); initMobileMenu(); initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
